import db from '../../firebase/firebaseconfig'

import userStore from "@/store/user.store"

import router from '@/router'

export const createLogDB = async (data) => {
  try {
    const result = await db.firestore().collection('userLog').add(data)

    const docId = result.id;

    if (docId) {
      data.userLogId = docId
      userStore.commit('setUserLog', data)
    }

  } catch (error) {
    console.log(error)
  }
}

export const updateLogBD = async (data) => {
  const docId = data.userLogId;

  db.firestore().collection('userLog').doc(docId).update(data).then(() => {
    
    userStore.commit('clearUser')

    router.push('/usersignin')
  })

  
}